import gql from 'graphql-tag';

export const NAME =
  'compositions_TechAdmin_DealerDetails_Contacts_contactsQuery';

export default gql`
  query ${NAME} (
    $id: ID!
  ) {
    afterHoursContacts (
      input: {
        dealerId: $id,
      }
    ) {
      contacts {
        canDelete,
        id,
        jobTitle,
        name,
        primaryPhoneNumber,
        secondaryPhoneNumber
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/Contacts/withContacts/contactsQuery.js